export default function UploadInfoBar({ uploadResponse }) {
  if (!uploadResponse?.uploaded_pdf_count || uploadResponse.uploaded_pdf_count <= 0) return null;
  return (
    <div className="bg-white/90 backdrop-blur-xl shadow-sm border-b border-gray-200/50 p-5">
      <div className="flex items-center gap-4">
        <div className="flex items-center gap-3 bg-gradient-to-r from-blue-50 to-purple-50 px-4 py-2 rounded-xl border border-blue-100">
          <div className="p-2 bg-white rounded-lg shadow-sm">
            <svg
              className="w-5 h-5 text-blue-600"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M7 21h10a2 2 0 002-2V9.414a1 1 0 00-.293-.707l-5.414-5.414A1 1 0 0012.586 3H7a2 2 0 00-2 2v14a2 2 0 002 2z"
              />
            </svg>
          </div>
          <span className="text-sm font-semibold text-gray-800">
            {uploadResponse.uploaded_pdf_count} file
            {uploadResponse.uploaded_pdf_count > 1 ? "s" : ""} uploaded
          </span>
        </div>
      </div>
    </div>
  );
}